module.exports = __webpack_public_path__ + "img/box6-07.e3244a35.png";